(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class CollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      if (!this.track) return;

      this.prevButton?.addEventListener('click', () => this.scrollByAmount(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByAmount(1));
      this.track.addEventListener('scroll', () => this.updateNavState(), { passive: true });
      window.addEventListener('resize', () => this.updateNavState());

      this.updateNavState();
    }

    scrollByAmount(direction) {
      const item = this.track.querySelector('[data-item]');
      if (!item) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
      const amount = item.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    updateNavState() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('collection-carousel')) {
    customElements.define('collection-carousel', CollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcement"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    // Whether an earlier page view was already dismissed this session is
    // checked synchronously, before this element even exists (see the
    // inline <script> above) - that avoids a flash of the bar reappearing
    // then disappearing again on every new page load. This class only
    // needs to handle a live click.
    connectedCallback() {
      this.querySelector('[data-announcement-close]')?.addEventListener('click', () => {
        // Persisted per browser session (not permanently) since this is
        // promotional content that can change - a merchant editing the
        // announcement shouldn't stay hidden forever for a returning
        // visitor. Cleared again on a plain page refresh (see the inline
        // <script> above).
        sessionStorage.setItem('announcement-dismissed', '1');
        document.documentElement.style.setProperty('--announcement-height', '0px');
        this.remove();
      });
    }
  }

  class AnnouncementBarSlides extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.autoplay) return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      const speed = Number(this.dataset.autoplay) || 5;
      this.index = 0;
      this.timer = setInterval(() => this.advance(), speed * 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      this.slides[this.index].classList.remove('announcement-bar__slide--active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('announcement-bar__slide--active');
    }
  }

  if (!customElements.get('announcement-bar-slides')) {
    customElements.define('announcement-bar-slides', AnnouncementBarSlides);
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      // The sheet lives outside <sticky-header> in the DOM (a sibling, not a
      // descendant) so its z-index is compared directly against the
      // header's own instead of always painting above it as a descendant
      // would. That means hover/focus containment has to be checked
      // against both this element and the sheet explicitly below.
      this.sheet = document.querySelector('[data-menu-sheet]');
      this.backdrop = document.querySelector('[data-menu-backdrop]');
      this.header = this.closest('sticky-header');
      this.panels = this.sheet ? Array.from(this.sheet.querySelectorAll('[data-menu-panel]')) : [];
      this.items = Array.from(this.querySelectorAll('.header__menu-item'));
      this.menuList = this.querySelector('.header__menu');
      this.menubarLinks = this.items.map((item) => item.querySelector('a'));
      this.activeIndex = null;
      this.openTimer = null;
      this.openDelay = 150;
      this.closeTimer = null;
      this.closeDelay = 200;
      // Set while programmatically refocusing a trigger after Escape, so
      // the unified focus listener below updates roving tabindex without
      // also re-triggering open() and undoing the close() that just ran.
      this._suppressAutoOpen = false;

      if (this.sheet && this.menuList && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          // The sheet is flush to the screen's left edge, so its width
          // needs to reach the menu's right edge as rendered — including
          // whatever left padding/margin offsets the menu from that edge —
          // not just the menu's own content width.
          //
          // Rounded up rather than passed through raw: a fractional width puts
          // the inner's border-right on a half pixel, and the sheet is a
          // composited layer on desktop (will-change, in the stylesheet), so that
          // edge is resampled into a soft two-pixel line instead of a crisp one.
          const right = this.menuList.getBoundingClientRect().right;
          this.sheet.style.setProperty('--sheet-width', `${Math.ceil(right)}px`);
        });
        this.resizeObserver.observe(this.menuList);
      }

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-menu-trigger]');
        const link = item.querySelector('a');

        // Unified focus handler: fires on Tab, click, or any programmatic
        // .focus() call from the keyboard handlers below. It's the single
        // place that keeps roving tabindex in sync with wherever real DOM
        // focus actually is, and opens/closes the sheet exactly like the
        // existing hover system does, so keyboard and mouse both converge
        // on the same open()/close()/activeIndex state.
        link.addEventListener('focus', () => {
          this.setRovingTabindex(this.menubarLinks, link);
          if (this._suppressAutoOpen) return;

          if (trigger) {
            this.open(item.dataset.menuIndex);
          } else {
            this.close();
          }
        });

        if (trigger) {
          item.addEventListener('mouseenter', () => this.scheduleOpen(item.dataset.menuIndex));
          item.addEventListener('mouseleave', () => this.cancelScheduledOpen());
        } else {
          item.addEventListener('mouseenter', () => this.close());
        }
      });

      // Closing on mouseleave uses a grace-period timer rather than
      // checking whether relatedTarget lands inside the other element:
      // the row and the sheet are separate DOM subtrees (see above), and
      // relying on the pointer crossing that boundary in exactly the
      // right pixel is inherently flaky — sub-pixel rounding, the
      // sticky header repositioning, or just a fast diagonal mouse path
      // can land relatedTarget on neither, closing the sheet on a false
      // read. A short delay that's cancelled by re-entering either the
      // row or the sheet tolerates all of that.
      this.addEventListener('mouseenter', () => this.cancelScheduledClose());
      this.addEventListener('mouseleave', () => this.scheduleClose());

      this.sheet?.addEventListener('mouseenter', () => this.cancelScheduledClose());
      this.sheet?.addEventListener('mouseleave', () => this.scheduleClose());

      this.addEventListener('focusout', (event) => this.handleFocusOut(event));
      this.sheet?.addEventListener('focusout', (event) => this.handleFocusOut(event));

      this.backdrop?.addEventListener('click', () => this.close());

      this.menuList.addEventListener('keydown', (event) => this.handleMenubarKeydown(event));
      this.sheet?.addEventListener('keydown', (event) => this.handlePanelKeydown(event));

      // Keeps roving tabindex in sync within a panel too, symmetric to the
      // menubar-level focus listener above - covers arrow-key moves, clicks,
      // and the Escape handler's trigger.focus() alike.
      this.sheet?.addEventListener('focusin', (event) => {
        const link = event.target.closest('a[role="menuitem"]');
        const panel = link?.closest('[data-menu-panel]');
        if (!link || !panel) return;

        this.setRovingTabindex(Array.from(panel.querySelectorAll('a[role="menuitem"]')), link);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.activeIndex === null) return;

        const trigger = this.items
          .find((item) => item.dataset.menuIndex === this.activeIndex)
          ?.querySelector('[data-menu-trigger]');

        this.close();

        // trigger.focus() below fires the unified focus listener, which
        // would otherwise immediately call open() again and undo the
        // close() that just ran - see _suppressAutoOpen's declaration.
        this._suppressAutoOpen = true;
        trigger?.focus();
        this._suppressAutoOpen = false;
      });
    }

    handleFocusOut(event) {
      if (this.contains(event.relatedTarget) || this.sheet?.contains(event.relatedTarget)) return;
      this.close();
    }

    setRovingTabindex(list, activeEl) {
      list.forEach((el) => el.setAttribute('tabindex', el === activeEl ? '0' : '-1'));
    }

    focusFirstPanelItem(menuIndex) {
      const panel = this.panels.find((candidate) => candidate.dataset.menuIndex === menuIndex);
      const panelLinks = panel ? Array.from(panel.querySelectorAll('a[role="menuitem"]')) : [];
      panelLinks[0]?.focus();
    }

    handleMenubarKeydown(event) {
      const currentLink = event.target.closest('a[role="menuitem"]');
      if (!currentLink || !this.menubarLinks.includes(currentLink)) return;

      const pos = this.menubarLinks.indexOf(currentLink);

      switch (event.key) {
        case 'ArrowRight':
          event.preventDefault();
          this.menubarLinks[(pos + 1) % this.menubarLinks.length].focus();
          break;
        case 'ArrowLeft':
          event.preventDefault();
          this.menubarLinks[(pos - 1 + this.menubarLinks.length) % this.menubarLinks.length].focus();
          break;
        case 'Home':
          event.preventDefault();
          this.menubarLinks[0].focus();
          break;
        case 'End':
          event.preventDefault();
          this.menubarLinks[this.menubarLinks.length - 1].focus();
          break;
        case 'ArrowDown':
          if (currentLink.hasAttribute('data-menu-trigger')) {
            event.preventDefault();
            this.focusFirstPanelItem(currentLink.closest('.header__menu-item').dataset.menuIndex);
          }
          break;
        default:
          break;
      }
    }

    handlePanelKeydown(event) {
      const currentLink = event.target.closest('a[role="menuitem"]');
      const panel = event.target.closest('[data-menu-panel]');
      if (!currentLink || !panel) return;

      const panelLinks = Array.from(panel.querySelectorAll('a[role="menuitem"]'));
      const pos = panelLinks.indexOf(currentLink);

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          panelLinks[(pos + 1) % panelLinks.length].focus();
          break;
        case 'ArrowUp':
          event.preventDefault();
          panelLinks[(pos - 1 + panelLinks.length) % panelLinks.length].focus();
          break;
        case 'Home':
          event.preventDefault();
          panelLinks[0].focus();
          break;
        case 'End':
          event.preventDefault();
          panelLinks[panelLinks.length - 1].focus();
          break;
        case 'ArrowRight':
        case 'ArrowLeft': {
          event.preventDefault();
          const menubarPos = this.menubarLinks.findIndex(
            (link) => link.closest('.header__menu-item').dataset.menuIndex === panel.dataset.menuIndex,
          );
          const delta = event.key === 'ArrowRight' ? 1 : -1;
          const nextLink = this.menubarLinks[(menubarPos + delta + this.menubarLinks.length) % this.menubarLinks.length];

          nextLink.focus();
          if (nextLink.hasAttribute('data-menu-trigger')) {
            this.focusFirstPanelItem(nextLink.closest('.header__menu-item').dataset.menuIndex);
          }
          break;
        }
        case 'Tab':
          if (event.shiftKey && pos === 0) {
            event.preventDefault();
            this.close();

            // Same re-open guard as the Escape handler above: focusing the
            // trigger below would otherwise fire the unified focus listener
            // and immediately undo this close().
            this._suppressAutoOpen = true;
            document.getElementById(panel.getAttribute('aria-labelledby'))?.focus();
            this._suppressAutoOpen = false;
          }
          break;
        default:
          break;
      }
    }

    scheduleOpen(index) {
      this.cancelScheduledOpen();

      if (this.activeIndex !== null) {
        this.open(index);
        return;
      }

      this.openTimer = setTimeout(() => this.open(index), this.openDelay);
    }

    cancelScheduledOpen() {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }

    scheduleClose() {
      this.cancelScheduledClose();
      this.closeTimer = setTimeout(() => this.close(), this.closeDelay);
    }

    cancelScheduledClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    open(index) {
      this.cancelScheduledOpen();
      this.cancelScheduledClose();

      const panel = this.panels.find((candidate) => candidate.dataset.menuIndex === index);
      if (!panel) return;

      const previousIndex = this.activeIndex;
      const previousPanel = this.panels.find((candidate) => candidate.dataset.menuIndex === previousIndex);
      const isSwitch = previousPanel && previousPanel !== panel;

      if (isSwitch && !this.prefersReducedMotion()) {
        const direction = Number(index) > Number(previousIndex) ? 'forward' : 'backward';
        this.crossfadePanels(previousPanel, panel, direction);
      } else {
        this.panels.forEach((candidate) => {
          candidate.hidden = candidate !== panel;
        });
      }

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-menu-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', String(item.dataset.menuIndex === index));
      });

      this.sheet.classList.add('header-menu__sheet--open');
      this.backdrop?.classList.add('header-menu-backdrop--visible');
      this.header?.setAttribute('data-menu-open', '');
      this.activeIndex = index;
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    crossfadePanels(outgoing, incoming, direction) {
      const enterClass = direction === 'forward' ? 'header-menu__panel--enter-right' : 'header-menu__panel--enter-left';
      const exitClass = direction === 'forward' ? 'header-menu__panel--exit-left' : 'header-menu__panel--exit-right';

      // A rapid back-and-forth hover can re-enter a panel before its
      // previous exit's transitionend has fired. Cancel that pending
      // cleanup so it doesn't hide the panel out from under itself once
      // it eventually fires.
      if (incoming._pendingExitCleanup) {
        incoming.removeEventListener('transitionend', incoming._pendingExitCleanup);
        incoming._pendingExitCleanup = null;
      }

      outgoing.classList.remove('header-menu__panel--enter-right', 'header-menu__panel--enter-left');
      incoming.hidden = false;
      incoming.classList.remove('header-menu__panel--exit-left', 'header-menu__panel--exit-right');
      incoming.classList.add(enterClass);

      // Force the starting offset to commit before removing it, so the
      // browser has something to transition *from* instead of jumping
      // straight to rest.
      void incoming.offsetWidth;

      incoming.classList.remove(enterClass);
      outgoing.classList.add(exitClass);

      if (outgoing._pendingExitCleanup) {
        outgoing.removeEventListener('transitionend', outgoing._pendingExitCleanup);
      }

      // Filtered on target AND property, because transitionend bubbles: a
      // link inside the outgoing panel finishing its own :active transition
      // would otherwise fire this a frame into the exit and cut the panel to
      // display: none mid-slide. Not { once: true } for the same reason - the
      // listener has to survive the events it ignores.
      const finishExit = (event) => {
        if (event.target !== outgoing || event.propertyName !== 'transform') return;
        outgoing.removeEventListener('transitionend', finishExit);
        outgoing.hidden = true;
        outgoing.classList.remove('header-menu__panel--exit-left', 'header-menu__panel--exit-right');
        outgoing._pendingExitCleanup = null;
      };
      outgoing._pendingExitCleanup = finishExit;
      outgoing.addEventListener('transitionend', finishExit);
    }

    close() {
      this.cancelScheduledOpen();
      this.cancelScheduledClose();
      this.sheet.classList.remove('header-menu__sheet--open');
      this.backdrop?.classList.remove('header-menu-backdrop--visible');
      this.header?.removeAttribute('data-menu-open');
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-menu-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      this.activeIndex = null;
    }
  }

  class MobileMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-mobile-menu-toggle]');
      this.drawer = document.querySelector('[data-mobile-menu-drawer]');
      this.backdrop = document.querySelector('[data-menu-backdrop]');
      this.header = this.closest('sticky-header');
      this.mainPane = this.drawer?.querySelector('[data-mobile-menu-pane="main"]');
      this.subPanes = this.drawer ? Array.from(this.drawer.querySelectorAll('[data-mobile-menu-pane="sub"]')) : [];
      this.isOpen = false;
      this.activePane = this.mainPane;

      this.toggle?.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));

      this.drawer?.addEventListener('click', (event) => {
        const drill = event.target.closest('[data-mobile-menu-drill]');
        if (drill) {
          this.drillInto(drill.dataset.mobileMenuDrill);
          return;
        }

        if (event.target.closest('[data-mobile-menu-back]')) this.goBack();
      });

      this.backdrop?.addEventListener('click', () => this.close());

      // The two verbs src/menu-swipe.ts speaks. It owns the physics of the
      // swipe and none of the state: it reads the level off the DOM, drives the
      // transforms itself, and when the spring has finished travelling it asks
      // for the same transition the back button and the toggle ask for. Both
      // arrive at rest, with the surface already where the command will leave
      // it, so neither replays an animation.
      //
      // goBack(false): the drag has already performed the movement, so the
      // class-based slide must not run a second time on top of it.
      this.drawer?.addEventListener('mobile-menu:back', () => this.goBack(false));
      this.drawer?.addEventListener('mobile-menu:dismiss', () => this.close());

      // Announce the drawer so src/main.ts can bind that swipe. A bundle cannot
      // import from a section's inline script block or vice versa, and the
      // theme editor re-renders this whole section - so the binding has to be
      // re-established from here on every connect, not once at page boot.
      this.dispatchEvent(
        new CustomEvent('mobile-menu:connected', { bubbles: true, detail: { drawer: this.drawer } }),
      );

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen) return;

        if (event.key === 'Escape') {
          this.close();
          this.toggle?.focus();
          return;
        }

        if (event.key === 'Tab') {
          this.trapFocus(event);
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.moveFocus(event.key === 'ArrowDown' ? 1 : -1);
          return;
        }

        if (event.key === 'ArrowRight' && document.activeElement?.hasAttribute('data-mobile-menu-drill')) {
          event.preventDefault();
          this.drillInto(document.activeElement.dataset.mobileMenuDrill);
          return;
        }

        if (event.key === 'ArrowLeft' && this.activePane !== this.mainPane) {
          event.preventDefault();
          this.goBack();
        }
      });

      // A drawer left open through a viewport resize (rotation, devtools
      // responsive mode, a folding device) would strand html's scroll-lock
      // state and leave a sub-pane inert while the desktop nav is now what's
      // showing - nobody could recover from that except a reload. Close it
      // proactively the moment we cross into desktop width.
      window.matchMedia('(min-width: 750px)').addEventListener('change', (event) => {
        if (event.matches) this.close();
      });
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.resetToMainPane();
      this.drawer?.toggleAttribute('open', true);
      // Closed-drawer content sits behind a transform + pointer-events:
      // none, not display: none - visual hiding alone doesn't remove it
      // from Tab order. inert closes that gap for every element inside at
      // once, independent of which individual pane's own hidden state
      // happens to be.
      if (this.drawer) this.drawer.inert = false;
      this.backdrop?.classList.add('header-menu-backdrop--visible');
      this.header?.setAttribute('data-menu-open', '');
      this.toggle?.setAttribute('aria-expanded', 'true');
      if (this.toggle) this.toggle.textContent = this.toggle.dataset.labelClose;
      this.getFocusableInActivePane()[0]?.focus();
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.drawer?.toggleAttribute('open', false);
      if (this.drawer) this.drawer.inert = true;
      this.backdrop?.classList.remove('header-menu-backdrop--visible');
      this.header?.removeAttribute('data-menu-open');
      this.toggle?.setAttribute('aria-expanded', 'false');
      if (this.toggle) this.toggle.textContent = this.toggle.dataset.labelOpen;
      // No resetToMainPane() here, deliberately. It used to run synchronously,
      // which snapped a submenu back to level 1 while the drawer was still
      // visibly sliding out - the buyer watched the menu change its mind on the
      // way off screen. open() already calls it (see above), so level 1 on the
      // next open is guaranteed without it; while closed, a sub-pane simply
      // stays laid out with activePane pointing at it, which nothing reads
      // (the focus trap and the arrow keys are gated on isOpen, the drawer is
      // inert, and scroll-lock keys off [open]). Not deferred to transitionend
      // either: an untargeted transitionend in this file is what caused the
      // pane-cut bug fixed in switchPane below.
    }

    resetToMainPane() {
      this.subPanes.forEach((pane) => {
        if (pane._pendingExitCleanup) {
          pane.removeEventListener('transitionend', pane._pendingExitCleanup);
          pane._pendingExitCleanup = null;
        }

        pane.hidden = true;
        pane.classList.remove(
          'mobile-menu__pane--enter-right',
          'mobile-menu__pane--enter-left',
          'mobile-menu__pane--exit-left',
          'mobile-menu__pane--exit-right',
        );
      });

      if (this.mainPane) this.mainPane.hidden = false;
      this.activePane = this.mainPane;
    }

    drillInto(index) {
      const target = this.subPanes.find((pane) => pane.dataset.mobileMenuSubIndex === index);
      if (!target) return;
      this.switchPane(this.mainPane, target, 'forward');
    }

    goBack(animate = !this.prefersReducedMotion()) {
      if (!this.mainPane) return;

      const returningFrom = this.activePane;
      this.switchPane(this.activePane, this.mainPane, 'backward', animate);

      // Return focus to the trigger that drilled into this sub-pane - not
      // just the first main-pane item - mirroring HeaderMenu's Escape
      // handler, which refocuses the originating trigger rather than
      // picking arbitrarily.
      const originIndex = returningFrom?.dataset.mobileMenuSubIndex;
      this.mainPane.querySelector(`[data-mobile-menu-drill="${originIndex}"]`)?.focus();
    }

    // `animate` defaults to the reduced-motion answer, so the default argument
    // is exactly the condition this used to test inline. A swipe passes false:
    // the finger has already performed the travel, and replaying the class
    // slide on top of it would move the pane twice.
    switchPane(outgoing, incoming, direction, animate = !this.prefersReducedMotion()) {
      if (!outgoing || !incoming || outgoing === incoming) return;

      const enterClass = direction === 'forward' ? 'mobile-menu__pane--enter-right' : 'mobile-menu__pane--enter-left';
      const exitClass = direction === 'forward' ? 'mobile-menu__pane--exit-left' : 'mobile-menu__pane--exit-right';

      if (incoming._pendingExitCleanup) {
        incoming.removeEventListener('transitionend', incoming._pendingExitCleanup);
        incoming._pendingExitCleanup = null;
      }

      incoming.hidden = false;
      incoming.classList.remove('mobile-menu__pane--exit-left', 'mobile-menu__pane--exit-right');

      if (animate) {
        incoming.classList.add(enterClass);

        // Force the starting offset to commit before removing it, so the
        // browser has something to transition *from* instead of jumping
        // straight to rest.
        void incoming.offsetWidth;

        incoming.classList.remove(enterClass);
        outgoing.classList.add(exitClass);

        if (outgoing._pendingExitCleanup) {
          outgoing.removeEventListener('transitionend', outgoing._pendingExitCleanup);
        }

        // Filtered on target AND property, because transitionend bubbles: a
        // link or the back button inside the outgoing pane finishing its own
        // :active transition would otherwise fire this a frame into the exit
        // and cut the pane to display: none mid-slide. Not { once: true } for
        // the same reason - the listener has to survive the events it ignores.
        const finishExit = (event) => {
          if (event.target !== outgoing || event.propertyName !== 'transform') return;
          outgoing.removeEventListener('transitionend', finishExit);
          outgoing.hidden = true;
          outgoing.classList.remove('mobile-menu__pane--exit-left', 'mobile-menu__pane--exit-right');
          outgoing._pendingExitCleanup = null;
        };
        outgoing._pendingExitCleanup = finishExit;
        outgoing.addEventListener('transitionend', finishExit);
      } else {
        outgoing.hidden = true;
      }

      this.activePane = incoming;
      // Lands on the sub-pane's Back button (first focusable in DOM order)
      // when drilling in - immediate orientation plus an easy way to
      // reverse.
      this.getFocusableInActivePane()[0]?.focus();
    }

    getFocusableInActivePane() {
      if (!this.drawer) return [];
      return Array.from(this.drawer.querySelectorAll('a[href], button:not([disabled])')).filter(
        (el) => !el.closest('[hidden]'),
      );
    }

    trapFocus(event) {
      const focusable = this.getFocusableInActivePane();
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const current = document.activeElement;
      const isInside = focusable.includes(current);

      if (event.shiftKey) {
        if (!isInside || current === first) {
          event.preventDefault();
          last.focus();
        }
      } else if (!isInside || current === last) {
        event.preventDefault();
        first.focus();
      }
    }

    moveFocus(delta) {
      const focusable = this.getFocusableInActivePane();
      if (focusable.length === 0) return;

      const index = focusable.indexOf(document.activeElement);
      const nextIndex = index === -1 ? 0 : (index + delta + focusable.length) % focusable.length;
      focusable[nextIndex]?.focus();
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  class StickyHeader extends HTMLElement {
    // Only relevant on templates with the overlay treatment (see
    // .header--overlay in the stylesheet) - harmless to attach elsewhere,
    // since no CSS reacts to data-sticky-state without that class present.
    #observer = null;

    connectedCallback() {
      const sentinel = document.querySelector('[data-scroll-sentinel]');
      if (!sentinel) return;

      this.#observer = new IntersectionObserver(
        (entries) => {
          // A batch can hold several crossings (fast flick near the top);
          // only the last one reflects where the page actually is.
          const entry = entries[entries.length - 1];
          const next = entry.isIntersecting ? 'inactive' : 'active';
          if (this.dataset.stickyState !== next) this.dataset.stickyState = next;
        },
        { threshold: 0 },
      );
      this.#observer.observe(sentinel);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }
  }

  if (!customElements.get('header-menu')) {
    customElements.define('header-menu', HeaderMenu);
  }

  if (!customElements.get('mobile-menu')) {
    customElements.define('mobile-menu', MobileMenu);
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // How long the button says "Added" before going back to offering the add.
  // Long enough to read, short enough that the label a buyer is aiming at is
  // the one that will be there when they land. Restarted by every add, so a
  // run of them reads as one held confirmation. A dwell, not a transition,
  // which is why it is a number here rather than one of the duration tokens.
  const ADDED_FLASH_MS = 1200;

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.productUrl;
      this.abortController = null;
      this.changedGroupName = null;

      const dataScript = this.querySelector('[data-product-variants]');
      const data = dataScript
        ? JSON.parse(dataScript.textContent)
        : { optionNames: [], variants: [], inventory: {}, lowStockThreshold: 0, lowStockTemplate: '' };
      this.optionNames = data.optionNames;
      this.singleVariant = data.singleVariant === true;
      this.variants = data.variants;
      // Keyed by variant id - see the comment on the data script above for why
      // this can't come from variant.inventory_quantity.
      this.inventory = data.inventory ?? {};
      // Per variant, { stock, inCart } - see the comment on the data script
      // above. How many more this buyer may add is the difference, which is a
      // different question from `variant.available` and the one the button is
      // actually asking.
      this.limits = data.limits ?? {};
      this.lowStockThreshold = data.lowStockThreshold;
      this.lowStockTemplate = data.lowStockTemplate;
      this.labels = data.labels ?? {};

      this.handleChange = (event) => {
        const root = event.target;
        this.changedGroupName = root?.dataset?.name ?? null;
        this.updateOptionStock(root);
        // Before applyOptions(), and unconditionally: the buy state must
        // settle on every change, including the ones that resolve no variant
        // and therefore never reach the network at all.
        this.applyBuyState(this.collectSelections());
        this.applyVariantSpecs();
        this.applyOptions();
      };
      this.addEventListener('radio-group:change', this.handleChange);

      // The budget is spent by adding and given back by removing, and both
      // happen over Ajax without this section re-rendering. Unbound, the
      // button would go on offering the last unit after the buyer had taken
      // it - and, worse the other way round, keep refusing after they had put
      // it back. On `document` because the drawer owns every cart mutation
      // and announces them (snippets/cart-drawer.liquid).
      this.handleCartChanged = () => this.refreshCartCounts();
      document.addEventListener('cart:changed', this.handleCartChanged);

      // The success flash is the one part of the buy row that an event has to
      // tell us about - every other state is derived from whether the cart
      // holds this variant, which the markup already knows. Arming on our own
      // submit rather than reading the add response keeps the drawer from
      // having to describe what it added.
      // Deliberately NOT disabled for the length of the request, which is the
      // usual advice for a submit button and is wrong here: a second press of
      // Add to cart is not a double submit to be swallowed, it is a buyer
      // asking for two.
      //
      // Which makes counting the add on the tap the only thing holding the
      // ceiling. Waiting for the server's count means every press inside that
      // round trip is a press the ceiling never sees, and pressing quickly is
      // exactly what someone adding several does - so a variant with one left
      // would take as many as the buyer could tap before the first answer
      // came back.
      this.handleSubmit = () => {
        this.awaitingAdd = true;

        const variant = this.resolveVariant(this.collectSelections());
        if (!variant) return;
        const limit = this.limits[variant.id];
        if (!limit || typeof limit.stock !== 'number') return;

        limit.inCart = this.inCartFor(variant.id) + 1;
        this.applyBuyState(this.collectSelections());
      };
      this.addEventListener('submit', this.handleSubmit);

      this.handleCartAdded = () => {
        if (!this.awaitingAdd) return;
        this.awaitingAdd = false;
        this.flashAdded();
      };
      document.addEventListener('cart:added', this.handleCartAdded);

      // A refused add never became anything, so the row must not celebrate
      // it. The failure itself is spoken by the cart bubble.
      this.handleAddFailed = () => {
        this.awaitingAdd = false;
        // The optimistic count above was for an add that never happened. Take
        // the number from the cart rather than subtracting one back off, so a
        // failure cannot leave the ceiling a unit out either way.
        this.refreshCartCounts();
      };
      document.addEventListener('cart:add-failed', this.handleAddFailed);
    }

    disconnectedCallback() {
      this.removeEventListener('radio-group:change', this.handleChange);
      this.removeEventListener('submit', this.handleSubmit);
      document.removeEventListener('cart:changed', this.handleCartChanged);
      document.removeEventListener('cart:added', this.handleCartAdded);
      document.removeEventListener('cart:add-failed', this.handleAddFailed);
      clearTimeout(this.addedTimer);
    }

    // Say it, then stop saying it. The timer restarts on every add, so
    // holding the button down through three of them reads as one continuous
    // confirmation rather than three flickers.
    flashAdded() {
      const submit = this.querySelector('[data-product-form-submit]');
      if (!submit) return;

      submit.dataset.buyState = 'added';
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => {
        submit.dataset.buyState = 'idle';
      }, ADDED_FLASH_MS);
    }

    // Counted from the cart itself rather than inferred from what an add
    // answered with. An add reports the LINE it landed on, and a variant can
    // sit on more than one line, so inference drifts; summing is exact and
    // covers removals and quantity edits in the same pass.
    async refreshCartCounts() {
      // Nothing here has a ceiling, so nothing needs counting.
      const tracked = Object.values(this.limits).some((limit) => typeof limit?.stock === 'number');
      if (!tracked) return;

      let cart;
      try {
        const response = await fetch(this.dataset.cartUrl, { cache: 'no-store' });
        if (!response.ok) return;
        cart = await response.json();
      } catch {
        // The server is still the authority on an add; a stale count here
        // only costs the buyer a refusal they will at least see the reason
        // for.
        return;
      }

      for (const limit of Object.values(this.limits)) {
        if (limit) limit.inCart = 0;
      }
      for (const item of cart?.items ?? []) {
        const limit = this.limits[item?.variant_id];
        if (!limit) continue;
        limit.inCart += typeof item.quantity === 'number' ? item.quantity : 0;
      }

      this.applyBuyState(this.collectSelections());
    }

    collectSelections() {
      const selections = {};
      this.querySelectorAll('[data-slot="radio-group"]').forEach((root) => {
        const name = root.dataset.name;
        const value = root.getAttribute('data-value');
        if (name && value) selections[name] = value;
      });
      return selections;
    }

    // Each option's low-stock count is a cascade, not fully independent:
    // an option sums stock across every variant matching its own value AND
    // every EARLIER option's (lower position) currently-selected value -
    // later options are scoped to whatever's already chosen ahead of them
    // (mirrors the identical formula in snippets/product-options.liquid).
    // So changing an option must recompute its own number AND every LATER
    // option that already has a value (they depend on this one) - but
    // never an earlier option, which this one has no influence over.
    updateOptionStock(changedRoot) {
      const changedIndex = this.optionNames.indexOf(changedRoot?.dataset?.name);
      if (changedIndex === -1) return;

      const selections = this.collectSelections();
      const orderedRoots = [...this.querySelectorAll('[data-slot="radio-group"]')]
        .map((root) => ({ root, index: this.optionNames.indexOf(root.dataset.name) }))
        .filter(({ index }) => index >= changedIndex)
        .sort((a, b) => a.index - b.index);

      for (const { root, index } of orderedRoots) {
        const value = root.getAttribute('data-value');
        this.applyOptionStock(root, index, value, selections);
      }
    }

    // priorSelections is the full { name: value } map (this.collectSelections()) -
    // only the entries for options at a lower position than `index` are
    // used, matching prior_option.position < option.position server-side.
    applyOptionStock(root, index, value, priorSelections) {
      const stockEl = root.closest('[data-option-name]')?.querySelector('[data-product-option-stock]');
      if (!value || !stockEl) return;

      // Shopify's variant JSON has option1/option2/option3 as separate
      // fields - there's no .options array - so the position has to be
      // translated to a field name, same as the Liquid side does with
      // 'option' | append: option.position.
      const optionKey = `option${index + 1}`;
      const priorKeys = this.optionNames
        .map((name, i) => ({ name, key: `option${i + 1}` }))
        .filter((_, i) => i < index)
        .filter(({ name }) => priorSelections[name]);

      let total = 0;
      for (const variant of this.variants) {
        if (variant[optionKey] !== value) continue;
        if (!priorKeys.every(({ name, key }) => variant[key] === priorSelections[name])) continue;
        // null means "inventory not tracked by Shopify", matching the Liquid
        // side's `variant.inventory_management == 'shopify'` guard. Read from
        // the explicit map, NOT variant.inventory_quantity - the json filter
        // strips that field, so it is always undefined here.
        const quantity = this.inventory[variant.id];
        if (typeof quantity !== 'number') continue;
        total += quantity;
      }

      const showLowStock = this.lowStockThreshold > 0 && total > 0 && total <= this.lowStockThreshold;
      stockEl.hidden = !showLowStock;
      stockEl.textContent = showLowStock ? this.lowStockTemplate.replace('__COUNT__', String(total)) : '';
    }

    // Shopify's product page only resolves product.selected_or_first_available_variant
    // from a `?variant=<id>` URL parameter - there's no server-side resolution
    // from option name/value pairs - so the target variant has to be found
    // client-side first, matching each option's currently selected value
    // (in position order) against the embedded product.variants list.
    resolveVariantId(selections) {
      const variant = this.resolveVariant(selections);
      return variant ? variant.id : null;
    }

    resolveVariant(selections) {
      // Nothing to resolve when there is nothing to choose: the one variant
      // is already the selected one. Walking the options here would look for
      // a value no radio group exists to supply and conclude the product is
      // unbuyable.
      if (this.singleVariant) return this.variants[0] ?? null;

      return (
        this.variants.find((candidate) =>
          this.optionNames.every((name, index) => candidate[`option${index + 1}`] === selections[name]),
        ) ?? null
      );
    }

    // The buy state is client-owned, for the same reason the low-stock counts
    // are: everything needed is already in the embedded variant JSON, so it can
    // settle instantly instead of a network round-trip later - and, critically,
    // it settles even when no variant resolves at all. That case (a chosen
    // combination that simply doesn't exist as a variant, common on a partial
    // variant matrix) used to return early out of applyOptions() before the
    // fetch, leaving the button showing the PREVIOUS variant's state and the
    // hidden id input still pointing at it - so the shopper could add the wrong
    // variant to their cart. That silent early return is what read as "the
    // button sometimes updates and sometimes doesn't".
    // `null` for a variant with no ceiling this theme can know: inventory
    // Shopify does not track, or one set to keep selling when it runs out.
    // Both are configurations where the add is legitimate, so neither may be
    // treated as zero.
    remainingFor(variantId) {
      const limit = this.limits[variantId];
      if (!limit || typeof limit.stock !== 'number') return null;
      return Math.max(0, limit.stock - this.inCartFor(variantId));
    }

    inCartFor(variantId) {
      const inCart = this.limits[variantId]?.inCart;
      return typeof inCart === 'number' ? inCart : 0;
    }

    applyBuyState(selections) {
      const variant = this.resolveVariant(selections);

      const input = this.querySelector('[data-product-form-variant-id]');
      if (input) input.value = variant ? variant.id : '';

      // No variant means no section fetch to bring a price back, so the
      // previous variant's would stay up. Fall back to the product's own.
      // A variant that does resolve gets its price from the graft.
      if (!variant) {
        const price = this.querySelector('[data-product-price]');
        const fallback = this.querySelector('[data-product-price-fallback]');
        if (price && fallback) price.replaceChildren(fallback.content.cloneNode(true));
      }

      const submit = this.querySelector('[data-product-form-submit]');
      if (!submit) return;

      const complete = this.singleVariant || this.optionNames.every((name) => selections[name]);

      // Stock is not the whole question. Shopify only moves inventory at
      // checkout, so a variant with one unit left keeps reporting
      // `available: true` however many of it are already in this buyer's
      // cart - which is why the button used to stay enabled and let them tap
      // into a refusal the server had to issue.
      const exhausted = variant ? this.remainingFor(variant.id) === 0 : false;

      let label;
      if (!complete) {
        label = this.labels.selectOptions;
      } else if (!variant) {
        // Complete selection, no such variant.
        label = this.labels.unavailable;
      } else if (variant.available !== true) {
        label = this.labels.soldOut;
      } else if (exhausted) {
        label = this.labels.maxInCart;
      } else {
        label = this.labels.addToCart;
      }

      submit.disabled = !variant || variant.available !== true || exhausted;

      // The LABEL, not the button: the button holds a second, aria-hidden
      // span carrying the confirmation, and writing textContent on the
      // button would delete it.
      const labelEl = submit.querySelector('[data-product-form-label]');
      if (label && labelEl) labelEl.textContent = label;
    }

    // The specifications' variant rows (SKU, barcode), written from the
    // embedded variant JSON on every pick. graft() leaves the accordion alone
    // so its open state survives, which would leave these describing the
    // previous variant; an incomplete pick hides them again rather than show
    // a variant the buyer hasn't chosen. The item hides with them when they
    // were all it had.
    applyVariantSpecs() {
      const rows = this.querySelectorAll('[data-variant-spec]');
      if (rows.length === 0) return;

      const variantId = this.resolveVariantId(this.collectSelections());
      const variant = variantId
        ? this.variants.find((candidate) => String(candidate.id) === String(variantId))
        : null;

      for (const row of rows) {
        const value = variant?.[row.dataset.variantSpec] ?? '';
        const valueEl = row.querySelector('.product-specifications__value');
        if (valueEl) valueEl.textContent = value;
        row.hidden = value === '';
      }

      // In the editor the item stays, so a merchant can still select it.
      if (window.Shopify?.designMode) return;
      for (const item of this.querySelectorAll('[data-product-specifications]')) {
        const rowsInItem = item.querySelectorAll('.product-specifications__row');
        item.hidden = ![...rowsInItem].some((row) => !row.hidden);
      }
    }

    async applyOptions() {
      const selections = this.collectSelections();
      const variantId = this.resolveVariantId(selections);
      // No variant to fetch a section for. handleChange() has already settled
      // the buy state for this case, so there is nothing left to do here.
      if (!variantId) return;

      this.abortController?.abort();
      const controller = new AbortController();
      this.abortController = controller;

      const params = new URLSearchParams({ variant: variantId, section_id: this.sectionId });

      this.setAttribute('aria-busy', 'true');

      let html;
      try {
        // cache: 'no-store' - this response carries live availability, and
        // iOS Safari will otherwise happily re-serve a previously-visited
        // ?variant= render from its HTTP cache.
        const response = await fetch(`${this.productUrl}?${params}`, {
          signal: controller.signal,
          cache: 'no-store',
        });
        if (!response.ok) throw new Error(`product: fetch returned ${response.status}`);
        html = await response.text();
      } catch (error) {
        if (error.name !== 'AbortError') this.removeAttribute('aria-busy');
        return;
      }

      // abort() only rejects a request still in flight - one whose body has
      // already been read lands here regardless, so a superseded response could
      // otherwise graft the wrong variant over a newer selection.
      if (this.abortController !== controller) return;

      this.graft(new DOMParser().parseFromString(html, 'text/html'));

      const visibleUrl = new URL(this.productUrl, window.location.href);
      visibleUrl.searchParams.set('variant', variantId);
      history.replaceState({}, '', visibleUrl);

      this.removeAttribute('aria-busy');
    }

    // Grafts only the pieces that change with the selected variant - price,
    // add-to-cart state, and each option group's availability - rather than
    // replacing the whole section, so the gallery/accordion/scroll position
    // are undisturbed.
    graft(doc) {
      const oldPrice = this.querySelector('[data-product-price]');
      const newPrice = doc.querySelector('[data-product-price]');
      if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;

      // The variant id and the submit button are deliberately NOT grafted from
      // the response: applyBuyState() already set them from client data the
      // moment the option changed, and re-applying the server's version here
      // would be a second write landing a round-trip later - the same
      // double-write the low-stock counts had. They are re-asserted after the
      // option groups are swapped below, since that swap can re-introduce
      // server-rendered markup.

      // Each option group is a <div data-option-name> wrapping a label (which
      // carries the low-stock span - see snippets/product-options.liquid) and
      // a radio-group. The whole group is swapped, not just the radio-group
      // div, because radio-group.ts binds its controller to the root node
      // itself: reusing that same node while only swapping its innerHTML
      // would leave the OLD controller (wired to the now-removed children) in
      // place - re-hydrating it would just warn "called more than once for
      // the same root" and return that stale controller instead of binding
      // the fresh markup. A full-node swap gives each graft a clean,
      // never-bound root to hydrate, same as how main-collection.liquid's
      // filter toggle-groups get replaced.
      doc.querySelectorAll('[data-option-name]').forEach((newGroup) => {
        const name = newGroup.dataset.optionName;
        const oldGroup = this.querySelector(`[data-option-name="${CSS.escape(name ?? '')}"]`);
        if (!oldGroup) return;

        const isChangedGroup = name === this.changedGroupName;
        // Only worth restoring focus if it was actually in here to begin
        // with - a graft triggered from anywhere else shouldn't steal it.
        const hadFocus = oldGroup.contains(document.activeElement);
        const focusValue = isChangedGroup
          ? newGroup.querySelector('[data-slot="radio-group"]')?.getAttribute('data-value')
          : null;

        oldGroup.outerHTML = newGroup.outerHTML;

        const freshGroup = this.querySelector(
          `[data-option-name="${CSS.escape(name ?? '')}"] [data-slot="radio-group"]`,
        );
        freshGroup?.dispatchEvent(new CustomEvent('data-slot:hydrate', { bubbles: true }));

        // Re-hydrating the group the user just interacted with moves focus
        // to <body> (its old, clicked element is gone) - restore it to the
        // freshly-hydrated item matching their selection. preventScroll is
        // essential: iOS Safari scrolls focused elements into view, so
        // without it every single option tap yanks the viewport.
        if (focusValue && hadFocus) {
          freshGroup
            ?.querySelector(`[data-slot="radio-group-item"][data-value="${CSS.escape(focusValue)}"]`)
            ?.focus({ preventScroll: true });
        }
      });

      this.refreshOptionStock();
      this.applyBuyState(this.collectSelections());
    }

    // The low-stock counts are client-owned: applyOptionStock() computes the
    // same cascade the Liquid does but instantly on tap, so by the time a
    // response lands it already holds the final number. The graft above just
    // reinstated the server's rendering of them, so recompute from client
    // data - one authoritative source, and no second visible change landing
    // a network round-trip after the first. Safe to run after the loop:
    // data-slot:hydrate is a plain synchronous listener (src/main.ts), so
    // every fresh root already carries its data-value by now.
    refreshOptionStock() {
      const selections = this.collectSelections();
      for (const root of this.querySelectorAll('[data-slot="radio-group"]')) {
        const index = this.optionNames.indexOf(root.dataset.name);
        if (index === -1) continue;
        this.applyOptionStock(root, index, root.getAttribute('data-value'), selections);
      }
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  // Fixed mobile-only bar that scrolls to the real add-to-cart button rather
  // than submitting anything itself. Shown only while the real button is still
  // ahead of the shopper: not yet fully in view, and below the viewport rather
  // than above it. Fully in view is enough to hide it, with no clearance
  // margin: the form and the description+accordion paint over the bar (the stacking notes
  // on .product__form and .product__info above), but nothing covers
  // whatever lies under them, and a bar kept until the button had cleared it
  // showed through there next to the real button. Once the shopper has
  // scrolled past the button the bar stays hidden however far down they go,
  // since it only ever points down to the button, never back up to it. When
  // the form's app slot holds a button (blocks/_product-form-apps.liquid, ADR
  // 0028), the tap scrolls far enough to show it too.
  class MobileBuyBar extends HTMLElement {
    #observer = null;

    connectedCallback() {
      const realButton = document.querySelector('[data-product-form-submit]');
      if (!realButton) return;
      const appSlot = document.querySelector('[data-product-form-apps]');

      this.#observer = new IntersectionObserver(
        ([entry]) => {
          // rootBounds is null in a cross-origin frame (the theme editor);
          // the viewport's own height stands in for it there.
          const viewportBottom = entry.rootBounds?.bottom ?? window.innerHeight;
          const ahead = !entry.isIntersecting && entry.boundingClientRect.bottom > viewportBottom;
          this.style.visibility = ahead ? 'visible' : 'hidden';
        },
        { threshold: 1 },
      );
      this.#observer.observe(realButton);

      const trigger = this.querySelector('[data-mobile-cta-trigger]');
      trigger.addEventListener('click', () => {

        // Scroll just enough for the form's LAST button to land exactly where
        // this fixed trigger button currently sits, rather than centering it
        // in the viewport: Add to cart itself, or, when the app slot below it
        // renders something, the slot's last button, with Add to cart right
        // above it. The trigger's rect is stable across the scroll (it's
        // fixed in place), so comparing button-to-button (not bar-wrapper-to-
        // button, which would be off by the bar's own padding) gives the exact
        // delta for the two to end up overlapping. A zero-height slot is empty
        // (hidden, or its app blocks rendered nothing) and is ignored.
        const triggerRect = trigger.getBoundingClientRect();
        const buttonTop = realButton.getBoundingClientRect().top;
        let delta = buttonTop - triggerRect.top;
        const slotRect = appSlot?.getBoundingClientRect();
        if (slotRect && slotRect.height > 0) {
          // Never so far that Add to cart slides under the fixed header: a
          // tall stack of app blocks on a short viewport stops with Add to
          // cart just below it instead.
          const headerBottom = document.querySelector('.header')?.getBoundingClientRect().bottom ?? 0;
          delta = Math.max(delta, Math.min(slotRect.bottom - triggerRect.bottom, buttonTop - headerBottom - 16));
        }
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({ top: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }
  }

  if (!customElements.get('mobile-buy-bar')) {
    customElements.define('mobile-buy-bar', MobileBuyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-has-results') || this.observer) return;

      // A screen ahead, so the cards are usually in before anyone scrolls to
      // the skeletons.
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 100% 0px' },
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (response.ok) {
          const html = await response.text();
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('related-products');
          if (next?.hasAttribute('data-has-results')) {
            this.innerHTML = next.innerHTML;
            this.removeAttribute('data-loading');
            this.removeAttribute('aria-busy');
            this.setAttribute('data-has-results', '');
            return;
          }
        }
      } catch {}

      if (!window.Shopify?.designMode) this.collapseOffscreen();
    }

    // Removing the section moves everything below it up by its height, which
    // only goes unseen while the section is out of the viewport.
    collapseOffscreen() {
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.remove();
      });
      this.observer.observe(this);
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchCollections extends HTMLElement {
    async connectedCallback() {
      const terms = this.dataset.terms;
      if (!terms) return;

      const url = new URL(this.dataset.predictiveUrl, window.location.origin);
      url.searchParams.set('q', terms);
      url.searchParams.set('resources[type]', 'collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('section_id', 'search-collections');

      try {
        const response = await fetch(url);
        // Throttling (429) or any other failure just leaves the group absent -
        // collections are a bonus here, not the results themselves.
        if (!response.ok) return;

        const html = await response.text();
        const group = new DOMParser().parseFromString(html, 'text/html').querySelector('.results-group--collections');
        if (group) this.replaceChildren(group);
      } catch {
        return;
      }
    }
  }

  if (!customElements.get('search-collections')) {
    customElements.define('search-collections', SearchCollections);
  }

  } catch(e) { console.error(e); }
})();
})();
